<template>
    <span class="element-badge is--info">Synced on {{ lastSyncedDate }}</span>
    <button class="element-button--secondary element-button" title="Syncing Translation Keys will obtain all translatable fields from all learning objects in this project and generate a list"
        @click="syncKeys"
        :disabled="status">
        Sync Translation Keys
    </button>
</template>

<script>
import _ from 'lodash'
import api from '../api/translations'
import moment from 'moment'
import Echo from '../helpers/echo'

export default {
    components: {

    },
    props: {
        project: {
            type: Object,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
    },
    data () {
        return {
            inProgress: false,
            localeDictionary: this.locale?.dictionary ?? [],
        }
    },
    computed: {
        lastSyncedDate () {
            return this.project.translation_synced_at 
            ? moment(this.project.translation_synced_at).format('MMM D, YYYY h:mm A') 
            : 'Never'
        },
        status () {
            return (this.inProgress || this.disabled) ? 'disabled' : false
        }
    },
    methods: {
        async syncKeys() {
            this.inProgress = true
            const result = await api.syncProjectKeys(this.project.id)

            if (result?.errors) {
                console.error(errors)
                this.inProgress = false
                return
            }
        },
        setupEchoListener () {
            const uId = window?.userData?.user?.id ?? null
            if (uId)
            {
                Echo.private("App.Models.User." + uId)
                    .notification((notification) => {
                        if (notification?.extra?.action === 'translation-key-sync') {
                            console.log(notification)
                            this.inProgress = false

                            window.location.reload();
                        }
                    })
            }
        }
    },
    mounted () {
        this.setupEchoListener()
    }
}
</script>
